import { Button, Paper } from "@mui/material"
import { makeStyles } from "@mui/styles"
import React, { useState } from "react"
import ModalListProdutos from "../ModalListProdutos"
import api from "../../services/api"
import TicketProductListItem from "./TicketProductListItem"
import { toast } from "react-toastify"

const useStyles = makeStyles(() => ({
    contactDetails: {
        marginTop: 8,
        padding: 8,
        display: "flex",
        flexDirection: "column",
    },
}))

function TicketProducts({ ticket }) {
    const classes = useStyles()
    const [modalSelectProduct, setModalSelectProduct] = useState(false)
    const [loading, setLoading] = useState(false)
    const [products, setProducts] = useState(ticket.products)

    const handleAddProduct = async (product) => {
        try {
            setModalSelectProduct(false)
            setLoading(true)

            const hasProduct = products.find((item) => item.id === product.id)

            if (hasProduct) {
                await api.put(`/ticketProducts/${ticket.id}/${product.id}`, {
                    quantity: hasProduct.TicketProduct.quantidade + 1,
                    discount: 0,
                })

                const array = products

                const newArray = array.map((prod) => {
                    if (prod.id === product.id) {
                        return {
                            ...prod,
                            TicketProduct: {
                                quantidade:
                                    hasProduct.TicketProduct.quantidade + 1,
                                discount: 0,
                            },
                        }
                    }

                    return prod
                })

                setProducts(newArray)

                setLoading(false)
                return
            }

            const res = await api.post("/ticketProducts", {
                ticketId: ticket.id,
                productId: product.id,
            })

            if (res.status === 200) {
                let list = products

                list.push({
                    ...product,
                    TicketProduct: {
                        desconto: 0,
                        quantidade: 1,
                    },
                })

                setProducts(list)
            }

            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }

    const handleDeleteProduct = async ({ productId }) => {
        try {
            await api.delete(
                `/ticketProducts/?ticketId=${ticket.id}&productId=${productId}`,
            )

            setProducts(products.filter((item) => item.id !== productId))

            toast.success("Produto removido com sucesso")
        } catch (error) {
            toast.error("Erro ao editar produto")
        }
    }

    return (
        <>
            <ModalListProdutos
                open={modalSelectProduct}
                handleClose={() => setModalSelectProduct(false)}
                handleAdd={(item) => handleAddProduct(item)}
            />
            <Paper variant="outlined" className={classes.contactDetails}>
                {products?.map((product) => {
                    return (
                        <TicketProductListItem
                            key={product.id}
                            product={product}
                            ticketId={ticket.id}
                            onDelete={(id) =>
                                handleDeleteProduct({ productId: id })
                            }
                        />
                    )
                })}
                <Button
                    onClick={() => setModalSelectProduct(true)}
                    size="small"
                    loading={loading}
                    variant="outlined"
                    sx={{ mt: 1 }}
                >
                    Add Produto
                </Button>
            </Paper>
        </>
    )
}

export default TicketProducts
